import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { CreatableSelect } from '@dealstack/frontend/shared/components/forms/CreatableSelect/CreatableSelect';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

type EntityOption = { value: string; label: string; id?: string };

export const EntitySelectComponent = (props: {
	name: string;
	personIdFieldName: string;
	label: string;
	placeholder: string;
	options: EntityOption[];
	setOptions: React.Dispatch<React.SetStateAction<EntityOption[]>>;
}) => {
	const { name, personIdFieldName, label, placeholder, options, setOptions } = props;

	const tCapManage = useTranslationCapManage();
	const { control, setValue } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field }) => (
				<CreatableSelect
					value={field.value ?? null}
					onChange={(selectedValue) => {
						field.onChange(selectedValue || '');

						if (!selectedValue) {
							setValue(personIdFieldName, null);
							return;
						}

						const selectedOption = options.find(
							(option) => option.value === selectedValue
						);
						setValue(personIdFieldName, selectedOption?.id ?? null);
					}}
					data={options}
					label={label}
					placeholder={placeholder}
					size="md"
					clearable
					getCreateLabel={(query) => `${tCapManage('holdings.event.save')}: "${query}"`}
					onCreate={(query) => {
						const newOption = { value: query, label: query };

						setOptions((prevOptions) => [...prevOptions, newOption]);

						setValue(personIdFieldName, null);

						return newOption;
					}}
				/>
			)}
		/>
	);
};
